import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

// import user from './modules/user'

const store = new Vuex.Store({
  state: {
    token: null,
    admin: null,
    user: null
  },
  getters: {
    token: state => {
      return state.token
    },
    admin: state => {
      return state.admin
    },
    user: state => {
      return state.user
    }
  },
  mutations: {
    SET_TOKEN: (state, payload) => {
      state.token = payload.token
    },
    SET_ROLE: (state, payload) => {
      state.admin = payload.role
    },
    SET_USER: (state, payload) => {
      state.user = payload.user
    },
    DELETE_TOKEN: state => {
      state.token = null
    },
    DELETE_ROLE: state => {
      state.admin = null
    },
    DELETE_USER: state => {
      state.user = null
    }
  },
  actions: {
    createSession ({commit}, payload) {
      commit('SET_TOKEN', { token: payload })
    },
    setUserRole({ commit }, payload) {
      commit('SET_ROLE', { role: payload })
    },
    setUser({ commit }, payload) {
      commit('SET_USER', { user: payload })
    },
    destroySession ({commit}) {
      commit('DELETE_TOKEN')
      commit('DELETE_ROLE')
      commit('DELETE_USER')
    },
  },
  modules: {
    // user,
  },
  plugins: [createPersistedState({
    key: 'novaccess'
  })]
})

export default store
